import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {AppService} from '../../../app.service';
import {Constants} from '../../../shared/utils/constants';
import {LightboxCardComponent} from '../../../shared/components/lightbox-card/lightbox-card.component';
import {KycService} from '../kyc.service';
import {Permission} from '../../../models/permission.model';
import {CreditCardModel} from '../../../models/cms.model';

@Component({
  selector: 'fx-credit-card',
  templateUrl: './credit-card.component.html',
  styleUrls: ['./credit-card.component.sass']
})
export class CreditCardComponent implements OnInit {
  @ViewChild('lightboxCard') lightboxCard: LightboxCardComponent;
  @Input() permission: Permission;
  condition: any = {keyword: '', status: ''};
  pageInfo: any = {
    pageIndex: 1,
    pageSize: 10,
    totalRecord: 0,
  };
  params: any = {};
  listCredit = [];
  listCardStatus = Object.values(Constants.CARD_STATUS);
  cardInfo = new CreditCardModel();
  constructor(
    private service: KycService,
    private appService: AppService
  ) { }

  ngOnInit(): void {
    this.getListCreditCard();
  }
  navigateTo(element: string): void {
    const scrollElement = document.querySelector('#' + element);
    if (scrollElement){
      scrollElement.scrollIntoView({ behavior: 'smooth' });
    }
  }
  onSearch(): void {
    this.pageInfo.pageIndex = 1;
    this.getListCreditCard();
  }

  onKeyup(evt: KeyboardEvent): void {
    if (evt.keyCode === 13) {
      this.onSearch();
    }
  }

  getListCreditCard(): void {
    const params = {
      q: this.condition.keyword
        ? encodeURIComponent(this.condition.keyword.trim())
        : this.condition.keyword.trim(),
      status: this.condition.status,
      page: this.pageInfo.pageIndex,
      page_size: this.pageInfo.pageSize
    };
    this.service.getCreditCard(params)
      .subscribe(res => {
        if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
          this.listCredit = res.data;
          this.pageInfo.totalRecord = res.paging.total;
        }
      });
  }
  openImages(item: any, id): void {
    const keyData = id + 'Url';
    const option = {
      url: item[keyData]
    }
    const listBase = [];
    this.service.getImage(option)
      .subscribe(res => {
        // if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
        //   listBase.push(res.data.base64_data);
        //   this.lightboxCard.openModal(listBase);
        // }
      });
  }

  onChangeCreditCardProcess(vType, id, action, index): void {
    this.appService
      .confirm({
        title: `Are you sure that you want to ${
          action === 1 ? 'verify' : 'reject'
          } Credit Card?`,
        icon: 'fa fa-question-circle',
        ok: 'Ok',
        cancel: 'Cancel',
      })
      .subscribe((res) => {
        if (res.result) {
          const body = {
            credit_card_id: +(id),
            type: vType,
            status: action
          };
          this.service
            .updateCreditCardStatus(body)
            .subscribe((data: any) => {
              if (data.status === Constants.RESPONSE_STATUS.SUCCESS) {
                this.appService.showSuccess(
                  (action === 1 ? 'Verify' : 'Reject') + ' Successful!'
                );
                const keyParam = (vType === 'card_status')
                  ? 'cardStatus' : 'cardHandStatus';
                this.listCredit[index][keyParam] = action;
              } else {
                this.appService.showError(
                  data.message ||
                  (action === 1 ? 'Verify' : 'Reject') + ' Fail!'
                );
              }
            });
        }
      });
  }

  pageChanged(page: number): void {
    this.pageInfo.pageIndex = page;
    this.getListCreditCard();
  }

  getLabelStatusCard(status): string {
    switch (status) {
      case -1: {
        return 'unUpload';
      }
      case 0: {
        return 'Pending';
      }
      case 1: {
        return 'Approval';
      }
      case 2: {
        return 'Rejected';
      }
    }
  }

  getCreditCardInfo(item): void {
    this.cardInfo = item;
  }

}
